import { createReducer, on } from '@ngrx/store';
import {
  LoadOrganizationUsers,
  SetOrganizationUsers,
  SetOrganizationUserErrored,
  AddOrganizationUserSucceeded,
  UpdateOrganizationUserSucceeded,
  RemoveOrganizationUserSucceeded,
  AddOrganizationUserErrored,
  UpdateOrganizationUserErrored,
  RemoveOrganizationUserErrored,
} from './organization-user.actions';
import { AdminOrganizationUser } from 'src/app/admin/models/organization.model';
import { OrganizationUserApiError } from './organization-user.errors';

export const enum CallState {
  INIT = 'INIT',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
}

export interface OrganizationUserState {
  organizationUsers: AdminOrganizationUser[];
  organizationId: number;
  callState: CallState;
  apiError: OrganizationUserApiError;
}

const initialState: OrganizationUserState = {
  organizationUsers: [],
  organizationId: null,
  callState: CallState.INIT,
  apiError: null,
};

export const organizationUserReducer = createReducer(
  initialState,
  on(
    LoadOrganizationUsers,
    AddOrganizationUserSucceeded,
    UpdateOrganizationUserSucceeded,
    RemoveOrganizationUserSucceeded,
    (state, { organizationId }) => ({
      ...state,
      callState: CallState.LOADING,
      organizationId,
      organizationUsers: [],
    }),
  ),
  on(SetOrganizationUsers, (state, { users }) => ({
    ...state,
    callState: CallState.LOADED,
    organizationUsers: users,
  })),
  on(
    SetOrganizationUserErrored,
    AddOrganizationUserErrored,
    UpdateOrganizationUserErrored,
    RemoveOrganizationUserErrored,
    (state, { error }) => ({
      ...state,
      callState: CallState.ERROR,
      apiError: error,
    }),
  ),
);
